import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import { API_URL, FirebaseConfig, LOCAL_FIRESTORE_URL } from "./env";

/**
 * Initialize Firebase and Firebase Analytics
 */
export const initFirebase = (): Promise<void> => {
  if (firebase.apps.length === 0 && location.hostname === "localhost" && API_URL.includes("localhost")) {
    firebase.initializeApp(FirebaseConfig).firestore().settings({ host: LOCAL_FIRESTORE_URL, ssl: false });
  } else if (firebase.apps.length === 0) {
    firebase.initializeApp(FirebaseConfig).firestore();
  }
  return firebase.analytics
    .isSupported()
    .then((isSupported) => {
      if (isSupported) {
        firebase.analytics();
      }
    })
    .catch(console.warn);
};
initFirebase();

export const kFirestoreCollections = {
  messageThreads: "message_threads",
};
